import React from 'react';
import { Link } from 'gatsby';

import Button from '@/components/v2/global/Button';
import { TrustedBy } from './TrustedBy';
import LinkArrow from '../../global/LinkArrow';
import { Marquee } from './Marquee';
import Animation from '@/assets/v2/animations/predibase-hero.riv';
import { useRive } from '@rive-app/react-canvas';

export const HeroSection = ({
  announcement,
  title,
  description,
  cta,
  video,
  image,
}) => {
  const AnnouncementIcon = announcement?.icon || null;

  const { RiveComponent } = useRive(
    {
      src: Animation,
      stateMachines: 'State Machine',
      autoplay: true,
      useOffscreenRenderer: true,
    },
    { fitCanvasToArtboardHeight: true },
  );

  return (
    <section className="pt-24 lg:pt-36 relative">
      {AnnouncementIcon && (
        <div className="mb-16 relative">
          <div className="px-2 lg:px-16 flex items-center justify-start gap-2 relative z-10">
            <div className="relative">
              <AnnouncementIcon className="m-[1px] rounded-md shadow-[0px_23px_7px_0px_rgba(0,0,0,0.00),_0px_15px_6px_0px_rgba(0,0,0,0.01),_0px_8px_5px_0px_rgba(0,0,0,0.05),_0px_4px_4px_0px_rgba(0,0,0,0.09),_0px_1px_2px_0px_rgba(0,0,0,0.10)]" />
              <span className="absolute h-24 -translate-y-16 left-0 border-l border-[#EAEAEA]" />
              <span className="absolute h-24 -translate-y-16 right-0 border-r border-[#EAEAEA]" />
              <span className="absolute h-24 w-full -translate-y-16 bg-[linear-gradient(180deg,_white_0%,_rgba(255,255,255,0.8)_15%,_transparent_20%,_transparent_80%,_rgba(255,255,255,0.8)_85%,_white_100%)]" />
            </div>
            <div className="flex flex-col lg:flex-row gap-x-1">
              <span className="text-xs lg:text-sm">{announcement.title}</span>
              <div className="flex items-center gap-1 text-xs lg:text-sm leading-none">
                <LinkArrow to={announcement.description.link} color="orange">
                  {announcement.description.title}
                </LinkArrow>
              </div>
            </div>
          </div>
          <span className="absolute w-full h-full top-0 border-t border-[#EAEAEA]" />
          <span className="absolute w-full h-full bottom-0 border-b border-[#EAEAEA]" />
          <span className="absolute h-full w-full top-0 bg-[linear-gradient(90deg,_transparent_0%,_transparent_60%,_rgba(255,255,255,0.8)_70%,_white_80%,_white_100%)] xl:bg-[linear-gradient(90deg,_transparent_0%,_transparent_40%,_rgba(255,255,255,0.8)_50%,_white_60%,_white_100%)]" />
        </div>
      )}
      {/* Main Content */}
      <div className="relative px-2 md:px-8 lg:px-16">
        <h1
          className="text-[3rem] lg:text-[4rem] leading-none font-medium mb-6 max-w-3xl"
          dangerouslySetInnerHTML={{ __html: title }}
        />
        <p
          className="text-lg mb-6"
          dangerouslySetInnerHTML={{ __html: description }}
        />

        {/* CTAs */}
        <div className="flex items-center justify-start flex-wrap gap-4 mb-16">
          {cta.map((button, index) => (
            <Button
              key={index}
              as={Link}
              to={button.href}
              variant={button.type === 'primary' ? 'primary' : 'secondary'}
              className="w-full sm:w-auto"
            >
              {button.title}
            </Button>
          ))}
        </div>
      </div>
      <div className="relative lg:px-16 md:container lg:-mt-16 mb-8">
        {/* <div className="aspect-video w-full mb-8 relative">
          <iframe
            src={video}
            title="Predibase"
            className="w-full h-full"
            allow="autoplay; fullscreen; picture-in-picture"
            frameBorder="0"
            allowFullScreen
          />
          <svg
            width="6"
            height="6"
            viewBox="0 0 6 6"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="absolute -top-[3px] -left-[3px]"
          >
            <path d="M3 0V6" stroke="#FF622B" />
            <path d="M6 3L0 3" stroke="#FF622B" />
          </svg>
          <svg
            width="6"
            height="6"
            viewBox="0 0 6 6"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="absolute -top-[3px] -right-[3px]"
          >
            <path d="M3 0V6" stroke="#FF622B" />
            <path d="M6 3L0 3" stroke="#FF622B" />
          </svg>
          <svg
            width="6"
            height="6"
            viewBox="0 0 6 6"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="absolute -bottom-[3px] -left-[3px]"
          >
            <path d="M3 0V6" stroke="#FF622B" />
            <path d="M6 3L0 3" stroke="#FF622B" />
          </svg>
          <svg
            width="6"
            height="6"
            viewBox="0 0 6 6"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="absolute -bottom-[3px] -right-[3px]"
          >
            <path d="M3 0V6" stroke="#FF622B" />
            <path d="M6 3L0 3" stroke="#FF622B" />
          </svg>
        </div> */}
        {/* <img src={image} alt="" className="w-full h-full" /> */}
      </div>
      <div className="relative mb-8">
        <div className="w-full relative mx-auto aspect-[896.731/358]">
          <RiveComponent className="h-full" />
        </div>
      </div>
      <TrustedBy />
      <Marquee padding="py-12" />
    </section>
  );
};
